import { render, staticRenderFns } from "./AdminIpAccessSetting.vue?vue&type=template&id=4c21a15c&"
import script from "./AdminIpAccessSetting.vue?vue&type=script&lang=ts&"
export * from "./AdminIpAccessSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports